<template>
    <TransitionFadeY>
        <v-expansion-panels 
            v-if="mounted"
            class="news-table" 
            variant="accordion" 
            elevation="0">

            <slot></slot>

        </v-expansion-panels>
    </TransitionFadeY>
</template>

<script>
import { TransitionFadeY } from '@generio-ai/library-legacy/components/transitions'

export default {
    name: 'NewsTable',
    components: {
        TransitionFadeY
    },
    data() {
        return {
            mounted: false
        }
    },
    mounted() {
        this.mounted = true
    }
}
</script>

<style scoped>
.news-table {
    border-radius: 8px !important;
}
</style>